import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import LoginPage from "@/views/auth/LoginPage.vue";
import ForgotPassword from "@/views/auth/ForgotPasswordPage.vue";
import ResetPassword from "@/views/auth/ResetPasswordPage.vue";

import AppCameraTool from "@/app/shared/components/app-camera-tool/app-camera-tool.vue";

//Projects
import ProjectsBase from "@/views/projects/TheBase.vue";
import ProjectsRouter from "@/views/projects/router";

import LocalPatientList from "@/views/projects/local/LocalPatientList.vue";
import RemotePatientList from "@/views/projects/remote/RemotePatientList.vue";

import PlanningPage from "@/views/planning/PlanningPage";

import ReleaseNotes from "@/app/release-notes/release-notes.vue";
import AppDebugView from "@/app/debug/debug-view.vue";
import { projectsRoutes } from "@/app/projects";

Vue.use(Router);

const appRoutes = [
  { path: "/release-notes", name: "release-notes", component: ReleaseNotes },

  { path: "/debug-view", name: "app-debug-view", component: AppDebugView },

  {
    path: "/log",
    name: "Console",
    component: () => import("./views/Console.vue"),
  },

  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
    meta: {
      public: true,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      public: true, // Allow access to even if not logged in
      onlyWhenLoggedOut: true,
    },
  },

  {
    path: "/export-db",
    name: "ExportDb",
    component: () => import("@/app/debug/ExportDB.vue"),
  },

  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    props: (route) => ({ token: route.query.token }),
    meta: {
      public: true, // Allow access to even if not logged in
      onlyWhenLoggedOut: true,
    },
  },

  {
    path: "/",
    name: "local",
    redirect: "/v2/projects/projects-list-local",
    component: () => import("@/views/projects/ProjectsPage.vue"),
  },

  {
    path: "/remote",
    name: "remote",
    meta: { remote: true },
    component: () => import("@/views/projects/ProjectsPage.vue"),
  },

  { path: "/camera", name: "app-camera-tool", component: AppCameraTool },

  // Projects
  {
    path: "/projects",
    component: ProjectsBase,
    children: ProjectsRouter,
    meta: {
      goback: true,
    },
  },

  {
    path: "/local-patient-list",
    name: "LocalPatientList",
    component: LocalPatientList,
  },
  {
    path: "/remote-patient-list",
    name: "RemotePatientList",
    component: RemotePatientList,
    meta: {
      onlyOnline: true,
    },
  },

  {
    path: "/planning",
    name: "PlanningPage",
    component: PlanningPage,
    meta: {
      onlyOnline: true,
    },
  },
];

const routes = [...projectsRoutes, ...appRoutes];

const router = new Router({
  routes,
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(
    (record) => record.meta.onlyWhenLoggedOut
  );
  const loggedIn = !!localStorage.getItem("token");
  const isLoggedIn = store.state.auth.isLoggedIn;

  if (!isPublic && !loggedIn && !isLoggedIn) {
    return next({
      path: "/login",
      query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if ((loggedIn || isLoggedIn) && onlyWhenLoggedOut) {
    return next("/");
  }

  next();
});

export default router;
